module.exports = __webpack_public_path__ + "img/unknown.1bafab51.png";